export default __webpack_public_path__ + "video/flag-loop.mp4";